export default __webpack_public_path__ + "images/ZE.8f56bb1.png";